import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import docker from './docker';
import auth from './auth';
import cloud from './cloud';
import storage from './storage';

export default (history) => combineReducers({
  docker,
  auth,
  cloud,
  storage,
  router: connectRouter(history),
});
